import { isIE } from '@utils/browser'
import { ProgramsSlideBtnContainerBgBlur } from './BgBlur'

type Peops = {
  children: JSX.Element
}

export const ProgramsSlideBtnContainer = ({ children }: Peops): JSX.Element => {
  return (
    <div className="absolute top-[5vw] right-[-3vw] z-50 lg:w-[10vw] lg:h-[18vw] rounded-l-[100px]">
      <div className="relative w-full h-full">
        {!isIE() && <ProgramsSlideBtnContainerBgBlur />}
        <div className="absolute top-1/2 right-[2vw]">{children}</div>
      </div>
    </div>
  )
}
